import * as Yup from "yup";
import { joiEmailSchema } from "../../../utils/utils";

const nameRegex = /^[A-Za-z]+(?: [A-Za-z]+)*$/;

const isAnyAddressFieldFilled = (address: any) => {
  if (!address) return false;

  return [
    address.street,
    address.city,
    address.state,
    address.country,
    address.zipcode,
  ].some((value) => String(value || "").trim() !== "");
};

export const userProfileValidationSchema = Yup.object({
  fullName: Yup.string()
    .transform((value) => value?.trim())
    .matches(nameRegex, "Only alphabets and single spaces are allowed")
    .min(1, "Min 1 character required")
    .max(50, "Max 50 characters allowed")
    .required("Full Name is required"),

  email: Yup.string()
    .required("Email Address is required")
    .email("Invalid Email Address")
    .test("joi-email-check", "Invalid email format", function (value) {
      if (!value) return true;
      const { error } = joiEmailSchema.validate(value);
      return !error;
    }),

  profile_photo: Yup.mixed().optional().nullable(),

  phoneNumber: Yup.string()
    .transform((value) => value?.replace(/\D/g, "").slice(-10))
    .required("Phone Number is required")
    .matches(/^\d{10}$/, "Phone Number must be exactly 10 digits"),

  address: Yup.object({
    street: Yup.string()
      .trim()
      .max(200, "Max 200 characters allowed")
      .test(
        "street-required-if-any-address-filled",
        "Street is required",
        function (value) {
          const { parent } = this;
          if (!isAnyAddressFieldFilled(parent)) return true;
          return !!String(value || "").trim();
        }
      ),

    city: Yup.string().test(
      "city-required-if-any-address-filled",
      "City is required",
      function (value) {
        const { parent } = this;
        if (!isAnyAddressFieldFilled(parent)) return true;
        return !!String(value || "").trim();
      }
    ),

    state: Yup.string().test(
      "state-required-if-any-address-filled",
      "State is required",
      function (value) {
        const { parent } = this;
        if (!isAnyAddressFieldFilled(parent)) return true;
        return !!String(value || "").trim();
      }
    ),

    country: Yup.string().test(
      "country-required-if-any-address-filled",
      "Country is required",
      function (value) {
        const { parent } = this;
        if (!isAnyAddressFieldFilled(parent)) return true;
        return !!String(value || "").trim();
      }
    ),

    zipcode: Yup.string().test(
      "zipcode-required-if-any-address-filled",
      "Zipcode is required",
      function (value) {
        const { parent } = this;
        if (!isAnyAddressFieldFilled(parent)) return true;
        return !!String(value || "").trim();
      }
    ),
  }),
});